import { createColumnHelper } from '@tanstack/react-table';
import { useDispatch, useSelector } from 'react-redux';
import { useMemo } from 'react';

import { FORMAT_TO_SECONDS, showTimeString } from 'shared/lib';
import { useTableSettings } from 'shared/ui/table/visible-columns/use-table-settings';
import { TColumnDef } from 'shared/ui/table/types';
import { TABLE_TIME_COLUMN_WIDTH } from 'shared/ui/table/consts';

import { selectChargePointStatusesTable } from '../../../../redux/slices/tables/tables-slice';
import { setVisibleColumns, TableColumns, TableColumnsState } from '../store';
import { ChargePointStatusDto } from '../../../../models/status';

const columnHelper = createColumnHelper<ChargePointStatusDto>();

const DATA_COLUMNS: TColumnDef<ChargePointStatusDto, TableColumns>[] = [
  {
    accessorKey: 'id',
    id: 'date',
    header: 'Дата',
    cell: (props) => {
      const date = props.row.original.date || '';

      return date ? showTimeString(date, FORMAT_TO_SECONDS) : '';
    },
    minSize: TABLE_TIME_COLUMN_WIDTH,
  },
  {
    accessorKey: 'status',
    id: 'status',
    header: 'Статус',
  },
];

export const useColumns = () => {
  const dispatch = useDispatch();

  const settings = useSelector(selectChargePointStatusesTable);

  const settingsColumn = useTableSettings({
    columnHelper,
    columns: DATA_COLUMNS.map(({ id, header }) => {
      return {
        key: id,
        label: header as string,
        isChecked: settings[id],
      };
    }),
    settings,
    renderCell: () => '',
    setVisibleColumns: (cols: TableColumnsState) => {
      dispatch(setVisibleColumns(cols));
    },
  });

  const visibleColumns = useMemo(() => {
    const dataCols = settings
      ? DATA_COLUMNS.filter((el) => settings[el.id])
      : DATA_COLUMNS;

    return [...dataCols, settingsColumn];
  }, [settings]);

  return visibleColumns;
};
